import { motion } from "motion/react";
import ReactPlayer from "react-player";
import { Link } from "react-router";
import styled from "styled-components";

const Container = styled.div`
    position: relative;
    /* min-height: 70rem; */
    display: flex;
    flex-direction: column;

    background-color: var(--dark-blue);

    color: var(--white);

    padding: 5rem;
    gap: 2rem;
    /* z-index: 5; */

    justify-content: center;
    align-items: center;
    overflow: visible;

    > * {
        z-index: 1;
    }

    .pattern-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        inset: 0;
        overflow: hidden;
        z-index: 0;
    }

    .pattern {
        position: absolute;
        left: -10rem;
        top: -10rem;
        height: 55rem;
        /* background-color: red; */
        filter: brightness(0);
        opacity: 0.4;
        /* height: 100%; */
        z-index: 1;
    }

    .player {
        position: relative;
        /* background-color: black; */
        width: calc(100%);
        max-width: 60rem;
        aspect-ratio: 16/9;
        border-radius: 2rem;
        overflow: hidden;

        img {
            height: 100%;
            width: 100%;
            z-index: 1;
            filter: saturate(0.5) blur(1px);
            transition: 0.3s;
        }

        &:hover {
            img {
                filter: saturate(1) blur(0px);
            }

            button {
                svg {
                    scale: 1.1;
                }
            }
        }

        button {
            position: absolute;
            inset: 0;
            margin: auto;
            z-index: 2;
            svg {
                height: 7.5rem;
                width: 7.5rem;
                color: #ffffff;
                transition: 0.3s;
            }
        }
    }

    span.special {
        background-color: var(--cyan);
        border-radius: 3rem;
        padding: 0.25rem 1rem;
        transition: 0.3s;
    }

    .left {
        min-width: 23rem;
        h2 {
            color: #fff;
            font-family: "Professor Marbles 3 LV";
            font-size: 4rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.2925rem;
        }

        span {
            font-size: 5rem;
        }
    }

    .right {
        display: flex;
        flex-direction: column;
        gap: 3.5rem;
        text-align: left;

        .right-text-container {
            position: relative;
            display: flex;
            flex-direction: column;
            gap: 1rem;
            padding: 1rem;

            .top-frame {
                position: absolute;
                width: 17rem;
                top: -2.5rem;
                left: -2rem;
            }

            .bottom-frame {
                position: absolute;
                width: 17rem;
                bottom: -3rem;
                right: -2rem;
            }

            .title {
                font-family: Poppins;
                font-size: 2rem;
                font-style: normal;
                font-weight: 700;
                line-height: 2.3rem;
            }

            .description {
                color: #fff;
                font-family: Poppins;
                font-size: 1.2rem;
                font-style: normal;
                font-weight: 300;

                strong {
                    font-weight: 600;
                }
            }

            .end-text {
                color: var(--cyan);
                font-family: Poppins;
                font-size: 1.25rem;
                font-style: normal;
                font-weight: 600;
            }
        }
    }

    .right span {
        background: #50af4a;
        color: var(--white);

        /* &:hover {
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.9);
        } */
    }

    .right a {
        text-decoration: none;
        font-size: 2rem;
        color: #fff;
        font-family: "Professor Marbles 3";
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        &:hover {
            span.special {
                background-color: #3d9237;
            }
        }
    }

    .bottom {
        display: flex;
        max-width: 60rem;
    }

    .smurf-wrapper {
        position: absolute;
        bottom: 0;
        right: 0;
        overflow: visible;
        padding: 0 130px;

        img.background {
            position: absolute;
            right: 0;
            bottom: -40px;
            height: 18rem;
            /* width: 30rem; */
            z-index: 2;

            @media (max-width: 600px) {
                height: 12rem;
                bottom: -19px;
            }
        }

        img.smurf {
            position: relative;
            /* height: 15rem; */
            width: 15rem;
            z-index: 3;
        }
    }

    @media (max-width: 1000px) {
        .bottom {
            flex-direction: column;
            align-items: self-end;
        }
        .right,
        .left {
            display: flex;
            flex-direction: row;
            width: fit-content;
        }

        .right {
            flex-direction: column;
            padding-top: 2rem;
        }

        .smurf-wrapper .smurf {
            display: none;
        }
    }
`;

const BlueSection = () => {
    return (
        <Container>
            <div className="pattern-wrapper">
                <img src="/pattern-home.png" className="pattern"></img>
            </div>
            <div className="player">
                <ReactPlayer
                    width={"100%"}
                    height={"100%"}
                    url="https://youtu.be/_5MfnfQ6HaM"
                />
                {/* <img src="/background-blue.png" alt="video" />
                <button>
                    <MdPlayCircleOutline />
                </button> */}
            </div>
            <div className="bottom">
                <div className="left">
                    <h2>
                        A vila dos <span className="special">smurfs</span>
                    </h2>
                </div>
                <div className="right">
                    <div className="right-text-container">
                        <img
                            src="/top_frame.svg"
                            alt="image top frame"
                            className="top-frame no-shadow"
                        />
                        <img
                            src="/bottom_frame.svg"
                            alt="image bottom frame"
                            className="bottom-frame no-shadow"
                        />
                        <p className="title">
                            E se você tivesse a oportunidade de conhecer a vila
                            mágica dos Smurfs?
                        </p>
                        <p className="description">
                            Papai Smurf, o grande líder dessa comunidade, teve
                            uma grande ideia: convidar você a viver um dia como
                            um Smurf! Nossos convidados têm a oportunidade única
                            de estar entre essas criaturinhas azuis e viver
                            todas essas aventuras ao lado de sua família na{" "}
                            <strong>Vila dos Smurfs Park</strong>.
                        </p>
                        <p className="end-text">
                            Com mais de 15 atrações para toda a família,
                            embarque em uma aventura smurfincrível pela Vila dos
                            Smurfs, a Floresta Encantada e a Cabana do Gargamel.
                        </p>
                    </div>
                    <Link to="/historia">
                        <span className="special">Saiba mais</span>
                    </Link>
                </div>
            </div>
            <div className="smurf-wrapper">
                <motion.img
                    initial={{ x: 1000 }}
                    whileInView={{ x: 0 }}
                    className="smurf"
                    src="/blue-section/smurf.png"
                    transition={{ duration: 0.5 }}
                ></motion.img>
                <motion.img
                    initial={{ x: 1000 }}
                    whileInView={{ x: 0 }}
                    className="background"
                    src="/blue-section/background.png"
                    transition={{ duration: 0.5 }}
                ></motion.img>
            </div>
        </Container>
    );
};

export default BlueSection;
